import { render, staticRenderFns } from "./ArticleWeb0013.vue?vue&type=template&id=2d5cdcae&scoped=true&"
import script from "./ArticleWeb0013.vue?vue&type=script&lang=js&"
export * from "./ArticleWeb0013.vue?vue&type=script&lang=js&"
import style0 from "./ArticleWeb0013.vue?vue&type=style&index=0&id=2d5cdcae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5cdcae",
  null
  
)

export default component.exports